import React from 'react';
import styles from './Card.module.css';

const Card = ({
  title,
  subtitle,
  children,
  actions,
  className = '',
  hover = false,
  padding = '24px',
  style = {},
}) => {
  const cardStyles = {
    background: 'var(--gradient-surface)',
    border: '1px solid var(--color-border)',
    borderRadius: 'var(--radius-lg)',
    padding,
    transition: 'transform var(--transition-normal), border-color var(--transition-fast), box-shadow var(--transition-normal)',
    boxShadow: 'var(--shadow-md)',
    position: 'relative',
    overflow: 'hidden',
    ...style,
  };

  const handleMouseEnter = (e) => {
    if (!hover) return;
    e.currentTarget.style.borderColor = 'rgba(255, 90, 31, 0.45)';
    e.currentTarget.style.boxShadow = 'var(--shadow-glow), var(--shadow-lg)';
    e.currentTarget.style.transform = 'translateY(-4px)';
  };

  const handleMouseLeave = (e) => {
    if (!hover) return;
    e.currentTarget.style.borderColor = 'var(--color-border)';
    e.currentTarget.style.boxShadow = 'var(--shadow-md)';
    e.currentTarget.style.transform = 'translateY(0)';
  };

  return (
    <div
      style={cardStyles}
      className={[styles.card, className].filter(Boolean).join(' ')}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {(title || actions) && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: title || subtitle ? '16px' : 0,
          }}
        >
          <div style={{ flex: 1 }}>
            {title && (
              <h3
                style={{
                  margin: 0,
                  fontFamily: 'var(--font-display)',
                  fontSize: 'var(--text-lg)',
                  fontWeight: 800,
                  letterSpacing: '-0.02em',
                  color: 'var(--color-text-primary)',
                }}
              >
                {title}
              </h3>
            )}
            {subtitle && (
              <p
                style={{
                  margin: '4px 0 0 0',
                  fontSize: 'var(--text-sm)',
                  color: 'var(--color-text-muted)',
                }}
              >
                {subtitle}
              </p>
            )}
          </div>
          {actions && (
            <div style={{ display: 'flex', gap: 'var(--space-2)', marginLeft: '16px' }}>
              {actions}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
